import { render, staticRenderFns } from "./SharePriceTable.vue?vue&type=template&id=32f3896e&scoped=true"
import script from "./SharePriceTable.vue?vue&type=script&lang=ts"
export * from "./SharePriceTable.vue?vue&type=script&lang=ts"
import style0 from "./SharePriceTable.vue?vue&type=style&index=0&id=32f3896e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3896e",
  null
  
)

export default component.exports